module.exports = __webpack_public_path__ + "img/cape_verde.9b846b5.webp";